:host {
  display: contents;
}

.br-table-row {
  display: contents;
}

// Para quando existir table-header-row.scss
// border-bottom:
//   var(--surface-width-sm)
//   var(--br-table-header-row-divider-style)
//   var(--border-color);
